// extracted by mini-css-extract-plugin
export var container = "large-key-figure-module--container--3b55c";
export var containerWithImage = "large-key-figure-module--containerWithImage--27ae0";
export var description = "large-key-figure-module--description--ae51c";
export var iconLeft = "large-key-figure-module--iconLeft--3dc1f";
export var iconRight = "large-key-figure-module--iconRight--4f7ef";
export var image = "large-key-figure-module--image--8d081";
export var keyContainer = "large-key-figure-module--keyContainer--b8bdc";
export var keyContainerWithImage = "large-key-figure-module--keyContainerWithImage--dbc44";
export var keyFigure = "large-key-figure-module--keyFigure--e2a7b";
export var mainInfo = "large-key-figure-module--mainInfo--f131b";
export var mainInfoWithImage = "large-key-figure-module--mainInfoWithImage--d0ce7";
export var subtitle = "large-key-figure-module--subtitle--5dfe8";